import React from 'react';
import HeroSection from '../components/home/HeroSection';
import OurBrands from '../components/home/OurBrands';
import Host from '../components/home/Host';

const Home = () => {
  return (
    <div>
      <HeroSection />
      <OurBrands />
      <Host />
    </div>
  );
};

export default Home;

